<template>
  <hic-list-page ref="listPage" title="患者列表" :entities="entities" :condition="condition" @load="page" :loading="meta.loading" header-height="6rem" keyword-placeholder="患者姓名/床位号/证件号" exportable @export="download">
    <template slot="buttons">
      <el-button v-if="setting.isSimple" type="primary" size="small" icon="el-icon-user-solid" class="left-pad right-pad" @click="newPatient(null)">入院登记</el-button>
      <el-dropdown v-if="!setting.isSimple" split-button type="primary" size="small" @click="create">
        <i class="el-icon-document-add" /> 入院通知
        <el-dropdown-menu slot="dropdown">
          <hic-patient-selector @change="oldPatient" class="left-pad right-pad" />
          <el-dropdown-item disabled divided></el-dropdown-item>
          <el-button type="primary" style="width: 93%" size="small" icon="el-icon-user-solid" class="left-pad right-pad" @click="newPatient(null)">入院登记</el-button>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" size="small" icon="el-icon-document" class="left-pad right-pad" @click="exportHospitalizationFile()" v-loading.fullscreen.lock="this.meta.exportLoading" element-loading-text="档案文件下载中，请稍后！">{{ this.isAllData ? '全部导出档案文件' : '按条件导出档案文件' }}</el-button>
      <font size="2">{{ this.exportTime }}</font>
    </template>
    <template slot="search">
      <el-date-picker style="width: 270px" size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeDate"></el-date-picker>
      <hic-dict-selector dict-type="IpWard" v-model="condition.wardCode" class="left-pad condition-input" placeholder="请选择病区" size="small" @change="page"></hic-dict-selector>
      <!-- <el-input v-if="setting.isSimple" style="width: 13rem;margin-left: 1rem;" placeholder="请输入证件号" size="small" v-model="condition.keyword" clearable></el-input> -->
    </template>
    <template slot="extend">
      <el-tabs v-model="condition.state" @tab-click="page">
        <el-tab-pane v-if="!setting.isSimple" label="已登记" name="已登记"> </el-tab-pane>
        <el-tab-pane label="已入住" name="已入住"> </el-tab-pane>
        <el-tab-pane label="已离院" name="已离院"> </el-tab-pane>
        <el-tab-pane v-if="!setting.isSimple" label="已结算" name="已结算"> </el-tab-pane>
      </el-tabs>
    </template>
    <el-table-column label="床位号" align="left" prop="bedNo" sortable="custom" width="150">
      <template slot-scope="{ row }">
        <span class="sub-title">{{ row.bedNo }}</span>
      </template>
    </el-table-column>
    <el-table-column label="住院号" align="center" prop="ipNo" sortable="custom" width="150">
      <template slot-scope="{ row }">
        <el-link type="primary" @click="$refs.listPage.extendRow(row)">{{ row.ipNo }}</el-link>
      </template>
    </el-table-column>

    <el-table-column type="expand" width="30">
      <template slot-scope="{ row }">
        <el-card style="margin-left: 1rem; margin-right: 1rem">
          <el-row slot="header">
            <el-col :span="8" style="margin-top: -1.5rem; margin-bottom: -2.5rem">
              <el-row type="flex" align="middle">
                <h2 class="center">{{ row.patientName }}</h2>
                <el-tag type="primary" plain hit size="mini" class="left-pad">{{ row.state }}</el-tag>
                <el-tag type="danger" plain hit size="mini" class="left-pad" v-if="row.ifBaby">新生儿</el-tag>
              </el-row>
              <el-row style="margin-top: -0.5rem">{{ row.ipNo }}</el-row>
            </el-col>
            <el-col :span="16">
              <el-row type="flex" align="middle" justify="end">
                
                <el-button v-if="!setting.isSimple && row.state == Enum.HospitalizationState.已登记" type="primary" size="small" icon="el-icon-edit" @click="openEditor(row)" class="left-pad" plain>修改</el-button>
                <el-button v-if="!setting.isSimple && row.state == Enum.HospitalizationState.已登记" type="danger" size="small" icon="el-icon-delete" @click="cancel(row)" class="left-pad" plain>撤销</el-button>
                <el-button v-if="!setting.isSimple && row.state != Enum.HospitalizationState.已结算" type="success" size="small" icon="el-icon-money" @click="openDeposit(row)" class="left-pad" plain>按金管理</el-button>
                <el-button v-if="!setting.isSimple && (row.state == Enum.HospitalizationState.已入住 || row.state == Enum.HospitalizationState.已离院)" type="warning" size="small" icon="el-icon-bank-card" @click="openSttle(row)" class="left-pad" plain>费用结算</el-button>
                <el-button v-if="row.state != Enum.HospitalizationState.已结算" type="primary" size="small" icon="el-icon-edit" @click="openPatient(row)" class="left-pad" plain>患者详细</el-button>
              </el-row>
            </el-col>
          </el-row>
          <el-descriptions v-if="row.state == Enum.HospitalizationState.已入住 || row.state == Enum.HospitalizationState.已离院" title="在院情况" :column="4">
            <el-descriptions-item label="当前科室">{{ $utils.Dict.text(row.deptCode, "Dept") }}</el-descriptions-item>
            <el-descriptions-item label="当前病区">{{ $utils.Dict.text(row.wardCode, "IpWard") }}</el-descriptions-item>
            <el-descriptions-item label="床位编号">{{ row.bedNo }}</el-descriptions-item>
            <el-descriptions-item label="在院天数">{{ Math.trunc($utils.Dt.span(row.startDate, new Date(), "d")) }} </el-descriptions-item>
            <el-descriptions-item label="主治医师">{{ row.doctorName }}</el-descriptions-item>
            <el-descriptions-item label="责任护士">{{ row.nurseName }}</el-descriptions-item>
            <el-descriptions-item label="护理等级">{{ row.nursingGrade }}</el-descriptions-item>
            <el-descriptions-item label="危重等级">{{ row.criticalLevel }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions v-if="!setting.isSimple" title="财务情况" :column="4">
            <el-descriptions-item label="预交金额">{{ (getSumDeposit(row) || row.deposit) | fmtFloat(2) }} </el-descriptions-item>
            <el-descriptions-item label="记账金额">{{ (getSumBilling(row) || row.billing) | fmtFloat(2) }}</el-descriptions-item>
            <el-descriptions-item label="挂账状态">
              <el-tag v-if="row.ifBillingEnd" type="danger" plain hit size="mini">是</el-tag>
              <el-tag v-else type="info" plain hit size="mini">否</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="挂账时间">{{ row.billingEndDate }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="入院情况" :column="4">
            <el-descriptions-item label="入院时间">
              <span v-if="row.startDate">{{ row.startDate }}</span>
              <span v-else>待入院</span>
            </el-descriptions-item>
            <el-descriptions-item label="住院类型">{{ $utils.Dict.text(row.stayType, "IpStayType") }}</el-descriptions-item>
            <el-descriptions-item label="入院科室">{{ $utils.Dict.text(row.originalDeptCode, "Dept") }} </el-descriptions-item>
            <el-descriptions-item label="住院次数">第 {{ row.stayTimes }} 次</el-descriptions-item>
            <el-descriptions-item label="入院途径">{{ $utils.Dict.text(row.comeFrom, "IpComeFrom") }}</el-descriptions-item>
            <el-descriptions-item label="门诊医师">{{ row.opDoctorName }}</el-descriptions-item>
            <el-descriptions-item label="门诊科室">{{ $utils.Dict.text(row.opDeptCode, "Dept") }}</el-descriptions-item>
            <el-descriptions-item label="门诊诊断">{{ row.diagnosisName }}</el-descriptions-item>
          </el-descriptions>
          <el-descriptions v-if="row.state == Enum.HospitalizationState.已离院 || row.state == Enum.HospitalizationState.已结算" title="离院情况" :column="4">
            <el-descriptions-item label="离院时间">{{ row.endDate }}</el-descriptions-item>
            <el-descriptions-item label="离院方式">{{ row.leaveMode }}</el-descriptions-item>
          </el-descriptions>
        </el-card>
      </template>
    </el-table-column>

    <el-table-column label="姓名" prop="patientName" key="patientName" width="">
      <template slot-scope="{ row }">
        <span>{{ row.patientName }}</span>
      </template>
    </el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" width="50">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" width="80" align="right">
      <template slot-scope="{ row }">
        {{ row.patientAge }}
      </template>
    </el-table-column>
    <el-table-column v-if="setting.isSimple" label="科室" prop="deptCode" key="simpleDeptCode" width="150">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column v-else-if="condition.state == '已登记'" label="入院科室" prop="originalDeptCode" :filters="dict.Dept" :filter-multiple="false" column-key="originalDeptCode" key="originalDeptCode" width="150">
      <template slot-scope="{ row }">
        {{ row.originalDeptCode | dictText("Dept") }}
      </template>
    </el-table-column>
    <el-table-column v-else label="科室" prop="deptCode" :filters="dict.Dept" :filter-multiple="false" column-key="deptCode" key="deptCode" width="150">
      <template slot-scope="{ row }">
        {{ row.deptCode | dictText("Dept") }}
      </template>
    </el-table-column>

    <!-- <el-table-column v-if="condition.state=='已登记'" label="门诊诊断" prop="opDiagnosisName" key="opDiagnosisName">
    </el-table-column>
    <el-table-column v-else label="主要诊断" prop="diagnosisName" key="diagnosisName">
      <template slot-scope="{ row }"> 
        <span v-if="row.diagnosisName">{{ row.diagnosisName }}({{ row.diagnosisCode }}) </span>
      </template>
    </el-table-column>
    <el-table-column label="收费类别" align="center" prop="ipType"></el-table-column> -->

    <el-table-column v-if="condition.state != Enum.HospitalizationState.已登记" label="在院天数" align="right" min-width="80" key="days">
      <template slot-scope="{ row }">
        {{ Math.trunc($utils.Dt.span(row.startDate, new Date(), "d")) }}
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state != Enum.HospitalizationState.已登记" label="入院日期" align="center" min-width="150" prop="startDate" key="startDate">
      <template slot-scope="{ row }">
        {{ row.startDate | fmtDate }}
      </template>
    </el-table-column>
    <el-table-column v-if="condition.state == Enum.HospitalizationState.已离院 || condition.state == Enum.HospitalizationState.已结算" label="离院方式" align="center" prop="leaveMode" key="leaveMode">
      <template slot-scope="{ row }">
        <div>{{ row.leaveMode | dictText("IpLeaveMode") }}</div>
      </template>
    </el-table-column>

    <notice-dlg v-if="!setting.isSimple" :visible.sync="meta.noticeShow" @close="page"></notice-dlg>
    <PatientSimpleDialog v-if="setting.isSimple" :visible.sync="meta.patientShow" :info="entity" :id="patientCode" @saved="patientSaved" />
    <hic-patient-dialog v-else :visible.sync="meta.patientShow" :id="patientCode" editable />
    <deposit-dlg :visible.sync="meta.depositShow" :hospitalization="entities.selected" />
    <edit-dlg :entity="entity" :visible.sync="meta.editorShow" @close="page" @saved="page"></edit-dlg>
    <settle :visible.sync="meta.showSettle" from="patient" :ipNo="settingIpNo" :isNew="true"></settle>

  </hic-list-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      "settle": () => import("../settle/new"),
      "notice-dlg": () => import("./dlg_notice"),
      "deposit-dlg": () => import("./dlg_deposit"),
      "edit-dlg": () => import("./dlg_hospitalization_edit_dx"),
      PatientSimpleDialog: () => import("./dlg_patient_simple"),
      // "edit-dlg": () => import("./dlg_hospitalization_edit"),
    },
    data() {
      return {
        patientCode: null,
        title: "",
        date: null,
        settingIpNo:'',
        meta: {
          noticeShow: false,
          editorShow: false,
          patientShow: false,
          depositShow: false,
          loading: false,
          exportLoading: false,
          showSettle:false
        },
        condition: {
          state: null,
          sort: "bedNo",
          asc: true,
          pageSize: 100,
        },
        entities: {
          items: [],
          selected: null,
        },
        entity: {},
        hospitalizationFileStatistic: {}
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "setting","user"]),
      isAllData() {
        return !this.date && !this.condition.wardCode && !this.condition.keyword;
      },
      exportTime() {
        let time = '';
        if (!this.hospitalizationFileStatistic) {
          time = '无';
        } else {
          if (this.isAllData) {
            if (this.hospitalizationFileStatistic.allExportTime) {
              time = this.hospitalizationFileStatistic.allExportTime;
            } else {
              time = '无';
            }
          } else {
            if (this.hospitalizationFileStatistic.conditionExportTime) {
              time = this.hospitalizationFileStatistic.conditionExportTime;
            } else {
              time = '无';
            }
          }
        }
        
        return '上次导出时间：' + time;
      }
    },
    created() {
      if (this.setting.isSimple) {
        this.condition.state = this.Enum.HospitalizationState.已入住;
      } else {
        this.condition.state = this.Enum.HospitalizationState.已登记;
      }
      this.getHospitalizationFileStatistic();
    },
    methods: {
      create() {
        this.meta.noticeShow = true;
      },
      changeDate(d) {
        if (d) {
          this.condition.startDateSt = this.$utils.Fmt.date(d[0]) + " 00:00:00";
          this.condition.startDateEd = this.$utils.Fmt.date(d[1]) + " 23:59:59";
        } else {
          this.condition.startDateSt = null;
          this.condition.startDateEd = null;
        }

        this.page();
      },
      page() {
        this.meta.loading = true;
        api.Hospitalization.query(this.condition)
          .then((res) => {
            res.items.forEach((r) => {
              r.deposit = null;
              r.billing = null;
            });
            this.entities = res;
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      openPatient(row) {
        this.entity = row;
        // this.entity = this.$utils.Obj.clone(row);
        this.patientCode = row.patientCode;
        this.meta.patientShow = true;
      },
      openDeposit(row) {
        this.$set(this.entities, "selected", row);
        this.meta.depositShow = true;
      },
      openSttle(row) {
        this.$set(this, "settingIpNo", row.ipNo);        
        this.meta.showSettle = true;
      },
      openEditor(row) {
        this.entity = this.$utils.Obj.clone(row);
        this.meta.editorShow = true;
      },
      download() {
        api.Hospitalization.export(this.condition, "住院患者.xls", [
          { property: "patientName", title: "姓名" },
          { property: "patientGender", title: "性别", dict: "Gender" },
          { property: "patientAge", title: "年龄" },
          { property: "originalDeptCode", title: "入院科室", dict: "Dept" },
        ]);
      },
      getSumDeposit(row) {
        if (row.deposit) {
          return row.deposit;
        }
        api.Deposit.sum({ ipNo: row.ipNo }).then((res) => {
          this.$set(row, "deposit", res);
        });
        return 0;
      },
      getSumBilling(row) {
        if (!isNaN(row.billing)) {
          return row.billing;
        }

        api.Billing.sum({ ipNo: row.ipNo }).then((res) => {
          this.$set(row, "billing", res);
        });
        return 0;
      },
      oldPatient(code) {
        api.Hospitalization.query({
          patientCode: code,
          states: [this.Enum.HospitalizationState.已登记, this.Enum.HospitalizationState.已入住, this.Enum.HospitalizationState.已结算],
        }).then((res) => {
          if (res.items.length) {
            this.$message.warning("当前患者处于在院状态，无法重复办理入院！");
            return;
          }
          this.entity = {
            patientCode: code + "",
          };
          this.meta.editorShow = true;
        });
      },
      newPatient() {
        this.entity = {
          patientName: null,
          patientAge: null,
          patientGender: null,
          contactCompany: null,
          contactName: null,
          contactPhone: null,
          deptCode: this.user.deptCode,
          wardCode: null,
          bedId: null,
          doctorCode: null,
          nurseCode: null,
          patientIdNo: null,
          startDate: null,
          ifMedicalRecordReceived: false,
        };
        this.meta.editorShow = true; //共通患者页面
      },
      cancel(row) {
        this.$confirm(`确定要对患者 ${row.patientName} 执行撤销入院登记的操作吗？`)
          .then(() => {
            return api.Hospitalization.cancel(row.id);
          })
          .then((res) => {
            this.$message.success(`已撤销 ${row.patientName} 入院登记！`);
          })
          .catch((err) => {
            if (err && err != "cancel") {
              this.$message.error(err);
              console.log(err);
            }
          });
      },
      patientSaved(patient) {
        if (parseInt(this.entity.patientCode) != patient.id) {
          return;
        }
        this.$set(this.entity, "patientName", patient.name);
        this.$set(this.entity, "patientGender", patient.gender);
        this.$set(this.entity, "patientAge", patient.patientAge);
        this.$set(this.entity, "patientIdNo", patient.idNo);
        // this.entity.patientName = patient.name;
        // this.entity.patientGender = patient.gender;
        // this.entity.patientIdNo = patient.idNo;
        // api.Hospitalization.save(this.entity).then((res) => {
        //   this.entity.lockKey = res.lockKey;
        // });
      },
      getHospitalizationFileStatistic() {
        api.HospitalizationFile.statistic().then((res) => {
          this.hospitalizationFileStatistic = res;
        })
      },
      exportHospitalizationFile() {
        this.meta.exportLoading = true;
        let con = {}
        con.startDateSt = this.condition.startDateSt ? this.condition.startDateSt : '';
        con.startDateEd = this.condition.startDateEd ? this.condition.startDateEd : '';
        con.wardCode = this.condition.wardCode ? this.condition.wardCode : '';
        con.keyword = this.condition.keyword ? this.condition.keyword : '';
        api.HospitalizationFile.exportFile(con).then((res) => {
          this.$message.success("导出档案文件成功！");
          this.getHospitalizationFileStatistic();
          this.meta.exportLoading = false;
        })
      }
    },
  };
</script>
